import { render, staticRenderFns } from "./vodQuestionnaire.vue?vue&type=template&id=dea98688&scoped=true"
import script from "./vodQuestionnaire.vue?vue&type=script&lang=js"
export * from "./vodQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./vodQuestionnaire.vue?vue&type=style&index=0&id=dea98688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea98688",
  null
  
)

export default component.exports